
export class DispatchParameters {
	locCode: string = '';
	scheduleId: number = 0;
	dispatchId: number = 0;
}